<script lang="ts">
  import { page } from '$app/state';
  import { onMount, tick } from 'svelte';
  import { useSupabaseClient } from '~/lib/SupabaseProvider.svelte';
  import { premiumModal } from '~/modals/PremiumModal.svelte';
  import { paidModal } from './PostPaymentModal.svelte';
  import { refreshAll } from '$app/navigation';
  import { lapsedModal } from './SubscriptionLapsedModal.svelte';
  import { useQueryClient } from '@tanstack/svelte-query';
  import { getSubscriptionQueryKey } from './mutations.svelte';
  import type Stripe from 'stripe';
  import { invoiceErrorModal } from './InvoiceErrorModal.svelte';

  const queryClient = useQueryClient();
  const supabaseClient = useSupabaseClient();
  onMount(() => {
    if (!page.data.user) {
      return;
    }
    // update user payment status
    const channel = supabaseClient
      .channel('subscriptions-changes')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'subscriptions',
        },
        async (payload) => {
          const sub: Stripe.Subscription = payload.new.stripe_payload;
          queryClient.setQueryData<Stripe.Subscription>(
            getSubscriptionQueryKey(),
            sub,
          );
          // trigger reload on insert
          await refreshAll();
          premiumModal.pop();
          await tick();
          // open modal
          if (['trialing', 'active'].includes(sub.status)) {
            paidModal.push();
          } else if (
            [
              'incomplete',
              'incomplete_expired',
              'past_due',
              'canceled',
              'unpaid',
              'paused',
            ].includes(sub.status)
          ) {
            invoiceErrorModal.push();
          } else if (sub.cancel_at) {
            lapsedModal.push();
          }
        },
      )
      .subscribe();

    return async () => {
      await channel.unsubscribe();
    };
  });
</script>
